<div class="relative" (click)="toggleMenu()" tabindex="0">
  <div class="flex items-center space-x-3 cursor-pointer">
    <span *ngIf="!isMobileView()" class="text-sm font-medium text-gray-700 dark:text-dark-text">{{ currentUser.name
      }}</span>
    <div
      class="w-9 h-9 bg-brand-primary rounded-full flex items-center justify-center text-white text-sm font-semibold">
      {{ getCurrentUserInitial() }}
    </div>
  </div>

  <div *ngIf="dropdownOpen"
    class="absolute right-0 mt-2 w-48 bg-white/20 dark:bg-black/20 backdrop-blur-2xl border border-white/40 dark:border-white/10 rounded-2xl shadow-soft overflow-hidden z-50 animate-fadeIn">
    <button *ngFor="let option of menuOptions"
      class="w-full text-left px-4 py-3 text-sm text-gray-700 dark:text-dark-text hover:bg-black/5 dark:hover:bg-white/5 flex items-center gap-3 transition-colors duration-150"
      (click)="handleOptionClick(option)">
      <span class="material-symbols-rounded text-gray-500 dark:text-dark-muted">{{ option.icon }}</span>
      <span class="font-medium">{{ option.label }}</span>
    </button>
  </div>
</div>